// extracted by mini-css-extract-plugin
module.exports = {"card":"styles-module--card--2-ayZ","card__line":"styles-module--card__line--1pKgA"};